export const getWebsiteLanguage = (): string => {
  if (process.env.NEXT_PUBLIC_SITE_LOCALE) {
    return process.env.NEXT_PUBLIC_SITE_LOCALE.slice(0, 2);
  }

  return 'en';
};
